var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentComponent === 'tx-history')?_c('tx-history',{attrs:{"address":_vm.address}}):_vm._e(),_vm._v(" "),(_vm.currentComponent === 'tx-simple')?_c('tx-simple',{attrs:{"address":_vm.address,"shouldLoadPendings":_vm.shouldLoadPendings}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }